<template>
  <div class="layout-header-container">
    <div class="full-screen-width" />

    <div class="solid-1200px-width">
      <!-- 左侧 -->
      <div class="left">
        <img
          class="img_logo"
          :src="headerCustom.logoImg"
          alt="logo"
          @click="handleLogoClick"
          :style="headerCustom.imgStyle"
        />
        <template v-if="headerCustom.showLogoRightText">
          <div class="divider" />
          <div class="slogan" v-html="headerCustom.logoText"></div>
        </template>
      </div>
      <div class="right" v-if="headerCustom.showRight">
        还没有账号？
        <div class="el-button--primary btn" @click="handleRegisterClick" :style="headerCustom.btnStyle">点击注册</div>
      </div>
    </div>
  </div>
</template>

<script>
import { HEADER_CUSTOM, OFFICIAL_WEBSITE, REGISTER_URL } from "@/utils/constants/constants";
import { getDocumentReferer } from "@/utils/common";

export default {
  name: "LayoutHeaderCustom",
  data() {
    return {
      default: {
        showLogoRightText: true,
        showRight: true,
        imgStyle: {},
        logoImg: require("@/assets/img/SearchBar/logo.png"),
        logoText: `<div>每天更新<span class="red">80000</span>条招标信息</div>
          <div>涵盖超过<span class="red">4000万</span>家招标单位</div>`,
        btnStyle: {},
      },
    };
  },
  computed: {
    header() {
      return this.$store.getters["layout/header"];
    },
    headerCustom() {
      return { ...this.default, ...HEADER_CUSTOM.find((v) => v.id === this.header.options.customId).value };
    },
  },
  methods: {
    // 左上角logo点击
    handleLogoClick() {
      window.location.href = OFFICIAL_WEBSITE;
    },
    handleRegisterClick() {
      window.location.href = REGISTER_URL + "?referUrl=" + getDocumentReferer();
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/config";

.layout-header-container {
  position: relative;

  .full-screen-width {
    width: 100%;
    height: $layout-login-header-height;

    background-color: #fff;
    border-bottom: 1px solid #e8e8e8;
    box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 6%);
  }

  .solid-1200px-width {
    width: $layout-body-width;
    height: 100%;
    margin: 0 auto 0 calc(50% - calc($layout-body-width / 2));
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    display: flex;

    .left {
      // position: absolute;
      // top: 18px;
      display: flex;
      align-items: center;

      .img_logo {
        cursor: pointer;
        width: 188px;
        height: 54px;
      }

      .img_logo {
        cursor: pointer;
        width: 97px;
        height: 54px;
      }

      .divider {
        width: 1px;
        height: 32px;
        border: 1px solid #e8e8e8;
        margin-left: 10px;
      }

      .slogan {
        margin-left: 16px;
        font-size: 16px;
        font-family: Dream, Dream-Medium;
        font-weight: 500;
        color: #3e3b3a;
        line-height: 26px;
        // padding-top: 10px;
        ::v-deep .red {
          color: #e50113;
        }
      }
    }
    .right {
      height: 100%;
      position: absolute;
      top: 0;
      right: 82px;
      font-size: 12px;
      display: flex;
      align-items: center;

      .btn {
        width: 120px;
        margin-left: 10px;
        line-height: 34px;
        border-radius: 4px;
        text-align: center;
        font-size: 14px;
        cursor: pointer;
      }
    }
  }
}
</style>
